import React, { useContext } from 'react';
import PosicoesContext from '../../../../../context/posicoes.context';
import './aplicador.scss';
import { constantes } from '../../../../../constantes';
import { notify } from '../../../../../functions/notifications';
import { InverterDataAtualUS } from '../../../../../functions/helper';

function Aplicador() {
  const {
    temp, setarInformacoes, verificaAplicacao,
    setInput, input,
  } = useContext(PosicoesContext);

  const tratamentos = [
    'Ad Foliar',
    'Adjuvante',
    'Fungicida',
    'Herbicida',
    'Herbicida de Catação',
    'Inseticida',
    'Maturador',
    'Pré-Maturador',
    'Outro',
  ];
  const modalidade = [
    'Aérea',
    'Terrestre',
  ];

  return (
    <div id="aplicador">
      <div className="separator">
        <span>
          {constantes.classificacao.aplicador}
        </span>
      </div>
      <div className="inputs-aplicador-defensivos">
        <label id="label-tratamentoo" className="tratamento">
          <span>
            Tratamento
          </span>
          <select
            className="form-control"
            name="tratamento"
            id="tratamento"
            onChange={(e) => setarInformacoes(e, setInput((prevState) => ({
              ...prevState, [`${e.target.name}`]: e.target.value,
            })))}
          >
            {
                  tratamentos.map((item, index) => (
                    <option selected={index === 0} key={item} value={item}>{item}</option>
                  ))
                }
          </select>
        </label>
        <label id="label-aplicador" className="produtoAplicacao">
          <span>
            Produto
          </span>
          <input
            type="text"
            id="produtoAplicacao"
            name="produtoAplicacao"
            placeholder="Informe o produto utilizado"
            value={input.produtoAplicacao}
            onChange={(e) => setarInformacoes(e, setInput((prevState) => ({
              ...prevState, [`${e.target.name}`]: e.target.value,
            })))}
          />
        </label>
        <label id="label-modalidade" className="modalidade">
          <span>
            Modalidade
          </span>
          <select
            className="form-control"
            name="modalidade"
            id="modalidade"
            onChange={(e) => setarInformacoes(e, setInput((prevState) => ({
              ...prevState, [`${e.target.name}`]: e.target.value,
            })))}
          >
            {
                  modalidade.map((item, index) => (
                    <option selected={index === 0} key={item} value={item}>{item}</option>
                  ))
                }
          </select>
        </label>
        <label id="label-data" className="data">
          <span>
            Data
          </span>
          <input
            type="date"
            id="data"
            name="data"
            onChange={(e) => setarInformacoes(
              {
                target: {
                  name: 'data',
                  value: InverterDataAtualUS(e.target.value),
                },
              },
            )}
          />
        </label>
        <label id="label-horaInicial" className="horaInicial">
          <span>
            Hora Inicial
          </span>
          <input
            type="time"
            id="horaInicial"
            name="horaInicial"
            min="00:00"
            max="23:59"
            required
            onChange={(e) => setarInformacoes(
              {
                target: {
                  name: 'horaInicial',
                  value: e.target.value,
                },
              },
            )}
          />
        </label>
        <label id="label-horaFinal" className="horaFinal">
          <span>
            Hora Final
          </span>
          <input
            type="time"
            id="horaFinal"
            name="horaFinal"
            min="00:00"
            max="23:59"
            required
            onChange={(e) => setarInformacoes(
              {
                target: {
                  name: 'horaFinal',
                  value: e.target.value,
                },
              },
            )}
          />
        </label>
        <label id="id-input-aplicador" htmlFor="id-input-aplicador">
          <span>Importar KML</span>
          <input
            name="kml"
            type="file"
            onChange={() => {}}
          />
        </label>
        <button
          id="selecionar-mapa"
          type="button"
          data-dismiss="modal"
        >
          <span>
            Seleciona no Mapa
          </span>
        </button>
        <button
          onClick={() => {
            if (temp.positions.length > 2) {
              verificaAplicacao();
            } else {
              notify('warning', 'Ops!!!, você náo informou a área no mapa, revise.');
            }
          }}
          id="salvar-button"
          type="button"
        >
          <span>
            Salvar Dados
          </span>
        </button>
      </div>
    </div>
  );
}

export default Aplicador;
